export const handleRealTimeStoreQty = (_this) => {
  const { tableName } = _this.$router.currentRoute.params;
  if (!vm.$store.state[R3.getModuleName()].mainFormInfo) {
    return
  }
  const configData = vm.$store.state[R3.getModuleName()].mainFormInfo.formData;
  // 找到需要加实时库存的配置
  const storeQtyConfig = tableConfig[tableName];

  if (!configData.data.addcolums || !storeQtyConfig || _this.tabPanel[_this.tabCurrentIndex].tablename !== storeQtyConfig.addTabTableName) {
    return;
  }

  let _columns = _this.columns;
  let _rows = _.cloneDeep(_this.tabledata);

  // 获取查配销仓和逻辑仓的id
  const storeIdObj = getStoreIdObj({
    ...storeQtyConfig.storeIdParams,
    childs: configData.data.addcolums[0].childs,
  });
  if (!storeQtyConfig.require(storeIdObj)) return;
  const it = _columns.findIndex((i) => i.colname == storeQtyConfig.colKey);
  console.log(_columns,it)
  // 如果已经添加了,则代表已经计算过了,则不再请求
  if (it !== -1) {
    return;
  }
  _columns.splice(_columns.length, 0, ...storeQtyConfig.addColumns(getColumnsMap()));

  _this.resetTableData({
    _rows: _rows,
    ...storeIdObj,
  });
};

/**
 * saStoreId  配销仓ID
 * storeId  逻辑仓ID
 */
export const tableConfig = {
  /*
            1.渠道调拨单的明细中添加发货逻辑仓可用库存及发货配销仓可用库存的展示。
              需求详情：
              1.单对象页面在选择发货配销仓(SENDER_SA_STORE_ID)或发货逻辑仓(SENDER_CP_C_STORE_ID)并保存后，自动获取发货配销仓或发货逻辑仓的可用库存。发货配销仓变更或发货逻辑仓变更|清空保存后，同时刷新或清除配销仓和逻辑仓库存。
              2.翻页，刷新需刷新库存。
          */
  SG_B_CHANNEL_TRANSFER: {
    // 添加的tab表名
    addTabTableName: 'SG_B_CHANNEL_TRANSFER_ITEM',
    // 判断是否需要添加库存列的字段key
    colKey: 'SENDER_STORE_QTY',
    // 实时库存id参数,与添加的列一一对应
    storeIdParams: {
      saStoreId: 'SENDER_SA_STORE_ID', // 逻辑仓
      storeId: 'SENDER_CP_C_STORE_ID',
    },
    // 需要添加的列
    addColumns: (columnsMap) => {
      return [columnsMap.saStoreId, columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.saStoreId && storeIdObj.storeId;
    },
  },
  /*
  2.逻辑调拨单的明细中添加发货逻辑仓可用库存的展示。
    1.单对象页面在选择发货逻辑仓并保存后，自动获取发货逻辑仓的可用库存。发货逻辑仓变更保存后，同时刷新逻辑仓库存。
   2.翻页，刷新需刷新库存。
          */
  SG_B_STO_TRANSFER: {
    addTabTableName: 'SG_B_STO_TRANSFER_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'SENDER_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // SENDER_SA_STORE_ID 配销仓调拨单
  SG_B_SHARE_SA_TRANSFER: {
    addTabTableName: 'SG_B_SHARE_SA_TRANSFER_ITEM',
    colKey: 'SENDER_SA_STORE_QTY',
    storeIdParams: {
      saStoreId: 'SENDER_SA_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.saStoreId];
    },
    require: (storeIdObj) => {
      return storeIdObj.saStoreId;
    },
  },
  // CP_C_STORE_ID 盘亏单
  SG_B_STO_NVENTORY_PROFIT_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  //  部门借用单
  SG_B_STO_DEPARTMENT_RETURN_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  //  专供原码出库单
  SG_B_STO_EXCLUSIVELY_TAGLIA_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  //  包材领用出库单
  SG_B_STO_PACKING_MATERIAL_RETURN_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // 防伪码领用出库单
  SG_B_STO_SECURITY_CODE_RECEIVE_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // 报废单
  SG_B_STO_SCRAP_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // 虚拟出库单
  SG_B_STO_OTHER_OUT_VIRTUAL: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // 其他出库单
  SG_B_STO_OTHER_OUT: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
  // 上线期初出库单
  SG_B_STO_OTHER_OUT_OPENING: {
    addTabTableName: 'SG_B_STO_OTHER_OUT_ITEM',
    colKey: 'SENDER_STORE_QTY',
    storeIdParams: {
      storeId: 'CP_C_STORE_ID',
    },
    addColumns: (columnsMap) => {
      return [columnsMap.storeId];
    },
    require: (storeIdObj) => {
      return storeIdObj.storeId;
    },
  },
};

const getStoreIdObj = ({ saStoreId, storeId, childs }) => {
  const storeObj = {};
  childs.forEach((item) => {
    if (item.colname === saStoreId) {
      storeObj.saStoreId = item.refobjid;
    }

    if (item.colname === storeId) {
      storeObj.storeId = item.refobjid;
    }
  });
  return storeObj;
};
const getColumnsMap = () => {
  return {
    // 配销仓可用库存
    saStoreId: {
      pinned: 'right',
      issubtotal: true,
      agfilter: 'LIST',
      orderno: 2000,
      isak: false,
      display: 'text',
      length: 18,
      scale: 2,
      type: 'NUMBER',
      datelimit: 'all',
      isagfilter: false,
      isfilter: false,
      colname: 'SENDER_SA_STORE_QTY',
      isuppercase: false,
      isnotnull: false,
      ismodify: false,
      name: '配销仓可用库存',
      inputname: 'SENDER_SA_STORE_QTY',
      title: '配销仓可用库存',
      key: 'SENDER_SA_STORE_QTY',
      field: 'SENDER_SA_STORE_QTY',
      thAlign: 'center',
      tdAlign: 'right',
    },
    // 逻辑仓可用库存
    storeId: {
      pinned: 'right',
      issubtotal: true,
      agfilter: 'LIST',
      orderno: 2100,
      isak: false,
      display: 'text',
      length: 18,
      scale: 2,
      type: 'NUMBER',
      datelimit: 'all',
      isagfilter: false,
      isfilter: false,
      colname: 'SENDER_STORE_QTY',
      isuppercase: false,
      isnotnull: false,
      ismodify: false,
      name: '逻辑仓可用库存',
      inputname: 'SENDER_STORE_QTY',
      title: '逻辑仓可用库存',
      key: 'SENDER_STORE_QTY',
      field: 'SENDER_STORE_QTY',
      thAlign: 'center',
      tdAlign: 'right',
    },
  };
};
